// extracted by mini-css-extract-plugin
export default {"preview":"FootnotePreview_preview__nKevP"};